if (window.innerWidth <= 1023) {
  document.addEventListener('DOMContentLoaded', () => {
    const suggestions = document.querySelector('.search-modal__suggestions');
    const input = document.getElementById('search-form-header-Search-In-Modal');
    const form = document.querySelector('form.search-modal__form');
    const menuDrawerSearch = document.querySelector('.menu-drawer__search');

            if (suggestions && input) {
      let isFocused = false;

      input.addEventListener('focus', () => {
        isFocused = true;
        suggestions.classList.add('is-open');
        menuDrawerSearch.classList.add('is-open');
      });

      input.addEventListener('blur', () => {
        isFocused = false;
        // On mobile, hide immediately. On desktop, check hover state
        if (window.innerWidth <= 1023) {
          // Mobile: hide after a short delay to allow for touch
          setTimeout(() => {
            if (!isFocused) {
              suggestions.classList.remove('is-open');
              menuDrawerSearch.classList.remove('is-open');
            }
          }, 150);
        } else {
          // Desktop: only hide if mouse is not over input or suggestions
          if (!input.matches(':hover') && !suggestions.matches(':hover')) {
            suggestions.classList.remove('is-open');
            menuDrawerSearch.classList.remove('is-open');
          }
        }
      });
    }
  });
}